

const Oops = () => {
    return (
        <div>
            Oho! Tekniikka petti ja jotakin meni vikaan... Höhlä. Mutta pelaa uudestaan, toivottavasti ensi kierros menee loppuun asti!
        </div>
    )
}

export default Oops